module.exports = __webpack_public_path__ + "static/img/Logo3.b3942ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo3.png
// module id = 8R+w
// module chunks = 1